/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


/*export default {
  data() {
    return {
     menu:[]
    }
  },
  methods: {
    menuloadserkan() {
     alert("ss")
    const vm=this
      const soap = require('soap')
     const url = this.$store.state.serviceAddress
     //console.log(url)
     const args = {userId: '1'}
     soap.createClient(url, function(err, client){
     client.menuYukle(args, function(err, result){
     //const menuSon=JSON.parse(result.menuYukleResult)
     let s=result.menuYukleResult
      const o = JSON.parse(JSON.stringify(s))

     console.log(Object.values(o))
    vm.menu=Object.values(o)
     })
     })

    },
  },
  created() {
    this.menuloadserkan()
  },
}*/

/*export default { // Vue component
  data: [{
            url: "/",
            name: "Hızlı Satış",
            slug: "home",
            icon: "HomeIcon",
          },
          {
            url: "/page2",
            name: "Page 2",
            slug: "page2",
            icon: "FileIcon",
          }]
  

}*/
//export default listmenu

export default [
  /*{
    url: "/",
    name: "Hızlı Satışssssssssssssss",
    slug: "",
    icon: "HomeIcon",
    submenu: [
      {
        url: "/satis/hizlisatis",
        name: "Hızlı Satışssssssssssssss",
        slug: "",
        icon: "HomeIcon"
      },
      {
        url: "/page2",
        name: "Hızlı Satışssssssssssssss",
        slug: "",
        icon: "HomeIcon"
      },
    ]

    
  },
  {
    url: "/",
    name: "Page 2ssssssssssssss",
    slug: "",
    icon: "FileIcon",
  },*/
]
/*export default [
  {
     "url" : "null",
     "name": "Hızlı Satış",
      "icon":"HomeIcon",
      "slug":"",
      "submenu":
       [
          {
             "url" : "/satis/hizlisatis",
              "name": "Satış",
               "icon":"",
               "slug":""
              },{ "url" : "/", "name": "Tahsilat", "icon":"FileIcon","slug":""},{ "url" : "satis/odeme", "name": "Ödeme", "icon":"FileIcon","slug":""},{ "url" : "satis/cariIade", "name": "Cari İade", "icon":"FileIcon","slug":""},{ "url" : "satis/bedelsizIade", "name": "Bedelsiz İade", "icon":"FileIcon","slug":""},{ "url" : "satis/hesapekstresi", "name": "Hesap Ekstresi", "icon":"FileIcon","slug":""} ] },{ "url" : "null", "name": "Muhasebe", "icon":"FileIcon","slug":"","submenu": [ { "url" : "muhasebe/alisFaturasi", "name": "Alış Faturası", "icon":"FileIcon","slug":""},{ "url" : "muhasebe/odeme", "name": "Ödeme", "icon":"FileIcon","slug":""},{ "url" : "muhasebe/cekGiris", "name": "Çek Senet Girişi", "icon":"FileIcon","slug":""},{ "url" : "muhasebe/girenUrunler", "name": "Giren Ürünler", "icon":"FileIcon","slug":""},{ "url" : "muhasebe/cariTanimla", "name": "Cari Tanımlama", "icon":"FileIcon","slug":""},{ "url" : "muhasebe/hesapBakiyeDurum", "name": "Hesap Bakiye Durum", "icon":"FileIcon","slug":""},{ "url" : "muhasebe/hesapBakiyeEkstresi", "name": "Hesap Bakiye Ekstresi", "icon":"FileIcon","slug":""},{ "url" : "muhasebe/acikIadeEkstresi", "name": "Açık İade Ekstresi", "icon":"FileIcon","slug":""} ] }]
*/